/**
 * Route guard for the Settings → Usage (AI Credits) page.
 *
 * Reads `isUsage` from the WorkspaceContext (server-derived, propagated via auth.me).
 * When false: redirects to the parent Settings page. When true: renders children.
 *
 * Intentionally NOT the localStorage dev-flag system (RequireFlag/FeatureFlagsContext): this
 * visibility gate is server-derived, but the `credits.*` data path remains auth/admin gated.
 */
import { Navigate } from 'react-router-dom';

import { useWorkspace } from '@/_shared/contexts/WorkspaceContext';

interface RequireUsageProps {
  children: React.ReactNode;
}

export function RequireUsage({ children }: RequireUsageProps): React.ReactElement {
  const { isUsage } = useWorkspace();

  if (!isUsage) {
    return <Navigate to=".." replace />;
  }

  return <>{children}</>;
}
